import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';
import Deadline from 'project/components/deadline';
import { getProject } from 'project/ducks/project';
import { toggleExtendModal, toggleCloseModal } from 'project/ducks/features';
import { canExtendDeadline, canClose } from 'project/utils';

export function mapStateToProps(state) {
  const { deadline } = getProject(state);

  return {
    deadline,
    showExtend: canExtendDeadline(state),
    showClose: canClose(state),
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    toggleExtendModal,
    toggleCloseModal
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Deadline);



// WEBPACK FOOTER //
// ./project/containers/deadline.js